import { MediaSummaryCard, type MediaSummaryView } from '../MediaSummaryCard/MediaSummaryCard';
import type { WidgetBlockProps } from '../shared/cardShell';

export type MediaPositiveMentionsCardProps = WidgetBlockProps & { view?: MediaSummaryView };

/** Figma `2123:83788` — `positiveMentions` over coverage rows. */
export function MediaPositiveMentionsCard(props: MediaPositiveMentionsCardProps) {
  return (
    <MediaSummaryCard
      {...props}
      title="Positive mentions"
      helpText="Published media stories classified as positive toward your brand during the selected period."
    />
  );
}
